import {http, httpCustom} from './config';

export default {
    getResumREservesNextExpire: () => {
        return http.get('api/v1/reservas/resumo-proximas-expirar');
    },
    create: (reserve, allotment_id) => {
        return httpCustom.post('api/v1/reservas', reserve, {headers: {"allotment-id": allotment_id}});
    },
    update: (data) => {
        return httpCustom.put(`api/v1/reservas/${data.id}`, data);
    },
    index: (filter, allotment_id = null, page = 1, perpage = null, exportIn = '') => {
        if (perpage === 'selecione' || !perpage) perpage = null;
        let responseType = exportIn === 'xls' ? 'blob' : '';
        return httpCustom.get('api/v1/reservas?page=' + page, {
            params: {...filter, perpage, exportIn},
            headers: {"allotment-id": allotment_id},
            responseType,
        });
    },
    historic: (reserve_id, allotment_id) => {
        return httpCustom.get('api/v1/reservas/historico/' + reserve_id, {headers: {"allotment-id": allotment_id}});
    },
    renew: (reserve_id, allotment_id) => {
        return httpCustom.get('api/v1/reservas/renovar/' + reserve_id, {headers: {"allotment-id": allotment_id}});
    },
    drop: (reserve_id, allotment_id, rasonRevocation) => {
        return httpCustom.post('api/v1/reservas/revogar/' + reserve_id, {'reason_revocation': rasonRevocation}, {
            headers: {"allotment-id": allotment_id},
        });
    },
    undetermined: (reserve_id, allotment_id) => {
        return httpCustom.get('api/v1/reservas/indeterminada/' + reserve_id, {headers: {"allotment-id": allotment_id}});
    },
    confirm: (reserve_id, reserve, allotment_id) => {
        return httpCustom.post('api/v1/reservas/confirmar/' + reserve_id, reserve, {headers: {"allotment-id": allotment_id}})
    },
    getConfirmedReservesByBlock: (block, allotment_id) => {
        return httpCustom.get('api/v1/reservas/confirmadas/' + block, {headers: {"allotment-id": allotment_id}});
    },
    show: (id) => {
        return httpCustom.get('api/v1/reservas/' + id);
    },
    generateProposalLink: (id, sendWhatsapp, allotment_id) => {
        return httpCustom.post(`api/v1/reservas/${id}/link-proposta`, {enviar_whatsapp: sendWhatsapp}, {
            headers: {'allotment-id': allotment_id},
        });
    },
    listProposalLinks: (id, allotment_id) => {
        return httpCustom.get(`api/v1/reservas/${id}/link-proposta`, {headers: {'allotment-id': allotment_id}});
    },
    revokeProposalLink: (linkId, allotment_id) => {
        return httpCustom.delete(`api/v1/reservas/link-proposta/${linkId}`, {headers: {'allotment-id': allotment_id}});
    },
    plusTime: (id, time) => http.post(`api/v1/loteamentos/${id}/aumentar-tempo-reservas`, {increase_time_on_reserves: time}),
    showProposals: (id, all = false) => {
        if (all) {
            return httpCustom.get('api/v1/reservas/' + id + '?onlyProposal=true&allProposals=true');
        }
        return httpCustom.get('api/v1/reservas/' + id + '?onlyProposal=true');
    },
    reservesByRealtor: (allotment_id, filter, page, orderBy = null, perPage = null) => {
        return httpCustom.get(`api/v1/reservas/${allotment_id}/corretores?page=${page}`, {
            params: {...filter, orderBy, perPage}
        });
    },
    verifyLimitReserve: (allotment_id) => {
        return httpCustom.get('/api/v1/reservas/permissao-reservas', {headers: {'allotment-id': allotment_id}});
    },
    attachClient: (data, id) => {
        return httpCustom.post(`/api/v1/reservas/vincular-client/${id}`, data)
    },
}
